@if (imageData) {
    <img class="img-fluid rounded"
        [src]="imageData"
        [style.width]="imageWidth() !== null ? imageWidth() : 'auto'"
        [style.height]="imageHeight() !== null ? imageHeight() : 'auto'"
        (click)="openModal()">
}
